import "./Instructions.css";
import { useState } from "react";
import Cookies from "js-cookie"; 

function Instructions() {
  const [checkBox, setCheckBox] = useState(false);


  function handleProceedToReg() {
    if(checkBox) {
      console.log("Everything is fine");
    }
    else {
      return;
    }
  }

  return (
    <>
      <div className="form-content">
        <div className="comp1">
          <center>
            <br />
            <b>
              <h3 className="sub">
                EXTRACT OF RELEVANT RULES REGARDING SUBMISSION OF THESIS
              </h3>
            </b>
            <h4 className="main-title">
              SUBMISSION OF Ph.D THESIS/M.Phil Dissertation.
            </h4>
          </center>
          <h4>
            <ul>
              <li>Upload the following.</li>
            </ul>
            <ol>
              <li>Completed application form</li>
              <li>Receipt of fee payment.</li>
              <li>
                Original Master's Degree Certificate or Equivalent Certificate
              </li>
              <li>Thesis/Dissertion</li>
              Simple PDF documnet consists of Scholar Statement, Supervisor's
              Certificate, Plagerism Certificate, all receipts with signatures
              of Supervisors, Head, BOS, Dean
            </ol>
          </h4>
          <center>
            <b>
              <h3 className="sub">GENERAL INSTRUCTIONS TO THE CANDIDATE.</h3>
            </b>
          </center>
          <h4>
            <ul>
              <li>
                Candidate is instructed to be very careful about the entries .
                The candidate will be held personally responsible for any
                incorrect entry that he/she makes.
              </li>
              <li>
                The name of the candidate and that of his/her father given here
                under should correspond to those mentioned in the Master's
                Degree or its equivalent Certificate.
              </li>
            </ul>
          </h4>
          <br />
        </div>
        <center>
          <div className="table-responsive">
            <p className="flow-of-thesis">FLOW OF THESIS SUBMISSION PROCESS</p>
            <div className="comp2">
              <br />
              <table
                className="table table-bordered"
                border="1"
                cellpadding="4"
              >
                <tr>
                  <td rowspan="1">01</td>
                  <td>
                    Obtain application form(collect from Publication Cell,KU)
                  </td>
                  <th colspan="2">
                    Duly signed by the Dean,Head,Chairperson and Supervisor
                  </th>
                </tr>
                <tr colspan="4">
                  <td rowspan="4">02</td>
                  <td rowspan="4">Online payment only</td>
                  <th rowspan="1">Rs. 12,000=00</th>
                  <td>Submission fee</td>
                </tr>
                <tr>
                  <th>Rs. 100=00</th>
                  <td> Submission Certificate</td>
                </tr>
                <tr>
                  <th rowspan="1">Rs. 15,000=00 </th>
                  <td>Submission fee(other Institutes ,i.e,KITS,IICT)</td>
                </tr>
                <tr>
                  <th>Rs. 100=00</th>
                  <td>Submission Certificate</td>
                </tr>
                <tr>
                  <th colspan="4">
                    <h3>
                      SBI Account No.52026910298
                      <br />
                      (IFSC Code:SBIN0020262(Used for RTGS/NEFT transactions))
                      <br />
                      Kakatiya University Branch.
                    </h3>
                  </th>
                </tr>
                <tr>
                  <td colspan="4">
                    <b>Required Documents:</b>
                  </td>
                </tr>
                <tr>
                  <td>03</td>
                  <td colspan="3">
                    <b>OBTAIN NO DUE CERTIFICATE</b>
                  </td>
                </tr>
                <tr>
                  <td>04</td>
                  <td colspan="3">
                    <b>ORDER</b>(Ph.D.Admission from the Dean) with{" "}
                    <b>Joining Report Xerox</b>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">05</td>
                  <td>
                    Extension Order
                    <br />
                    (From the Dean/Registrar)
                  </td>
                  <td colspan="02">
                    After completion of 4years <b>(for Full Time)</b>
                    <br />
                    After completion of 5years<b>(for Part Time)</b>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">06</td>
                  <td>
                    Title change order
                    <br />
                    (From the Dean)
                  </td>
                  <td colspan="02">If necessary</td>
                </tr>
                <tr>
                  <td rowspan="1">07</td>
                  <td>
                    <b>Two Seminars Certificates</b> (Duly signed by the
                    Dean,Head and Chairperson with stamps)
                  </td>
                  <td colspan="02">
                    <b>Originals</b>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">08</td>
                  <td>One or Two Publications</td>
                  <td colspan="02">
                    Xerox (Duly signed by the Dean,Head,Chairperson and
                    Supervisor)
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">09</td>
                  <td>
                    <b>Pre-Ph.D.Memo (or) M.PHIL.Certificate</b>
                  </td>
                  <td colspan="02">Xerox</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>PG Certificate</td>
                  <td colspan="02">Xerox</td>
                </tr>
                <tr>
                  <td>11</td>
                  <td colspan="3">
                    <b>Plagiarism Certificate</b>(Original copy in four Thesis
                    and Xerox copy with form)
                  </td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>Synopsis</td>
                  <td colspan="02">
                    <b>4 Copies</b>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">13</td>
                  <td>Thesis</td>
                  <td colspan="02">
                    <b>4 Hard Bound Copies</b>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">14</td>
                  <td>Soft Copy (Pendrive)</td>
                  <td colspan="02">
                    <b>01 (Synopsis & Thesis seperate folders)</b>
                  </td>
                </tr>
                <tr>
                  <td rowspan="1">15</td>
                  <td>Shodhganga Certificate after completion pf Viva-Voce</td>
                  <td colspan="5">
                    <b>At the time of issue of Press Note</b>
                  </td>
                </tr>
              </table>
              <br />
            </div>
          </div>
        </center>
        <br />
      </div>
    </>
  );
}
export default Instructions;

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  window.location.href = "/";
}
